import { IDeploymentAndValueStatsGroupedCount } from '@kcftech/prometheustypescriptapiclient';
import { VerticalScrollableBarChart } from 'pages/Dashboard/components/VerticalScrollableBarChart';
import { useMemo } from 'react';
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';
import { tokens } from 'styles/tokens';
import { sortBy } from 'utils/array';

export function DeploymentScope({
    data,
}: {
    data: IDeploymentAndValueStatsGroupedCount[];
}) {
    const mappedData = useMemo(() => {
        const mapped = data.map((d) => ({
            LocationName: d.Name,
            Count: d.Count,
        }));
        return sortBy(mapped, (d) => -d.Count);
    }, [data]);

    return (
        <VerticalScrollableBarChart
            xAxisHeight={30}
            dataLength={mappedData.length}
            minBarHeight={64}
        >
            {({ xAxisHeight }) => (
                <BarChart
                    layout="vertical" // this means "horizontal bars"
                    data={mappedData}
                    margin={{ top: 15, right: 15, left: 15, bottom: 5 }}
                >
                    <defs>
                        <linearGradient
                            id="deploymentScopeHorizontalBarColor"
                            x1="1"
                            y1="0"
                            x2="0"
                            y2="0"
                        >
                            <stop
                                offset="5%"
                                stopColor={tokens.primary.default}
                                stopOpacity={0.75}
                            />
                            <stop
                                offset="95%"
                                stopColor={tokens.primary.default}
                                stopOpacity={0.5}
                            />
                        </linearGradient>
                    </defs>

                    <CartesianGrid strokeDasharray="3 3" horizontal={false} />

                    <XAxis
                        type="number"
                        tickFormatter={(v) => v?.toLocaleString()}
                        fontSize={14}
                        height={xAxisHeight}
                    />

                    <YAxis
                        type="category"
                        dataKey="LocationName"
                        width={150}
                        fontSize={14}
                    />

                    <Tooltip />

                    <Legend />

                    <Bar
                        dataKey="Count"
                        fill="url(#deploymentScopeHorizontalBarColor)"
                        radius={[0, 5, 5, 0]}
                    ></Bar>
                </BarChart>
            )}
        </VerticalScrollableBarChart>
    );
}
